import React from 'react';
import { lazy } from 'react';
import RatingsAssignmentIcon from './RatingsAssignment';
import RatingsDecisionIcon from './RatingsDecision';
import RatingsLoopIcon from './RatingsLoop';
import RatingsBreakIcon from './RatingsBreak';
import RatingsThreadIcon from './RatingsThread';

const ActionMore = lazy(() => import('./IconActionMore'));
const Settings = lazy(() => import('./IconSettings'));
const Accounts = lazy(() => import('./IconAccounts'));
const Reports = lazy(() => import('./IconReports'));
const Lead = lazy(() => import('./IconLead'));
const Contacts = lazy(() => import('./IconContacts'));
const Opportunity = lazy(() => import('./IconOpportunity'));
const Cases = lazy(() => import('./IconCases'));
const Campaings = lazy(() => import('./IconCampaings'));
const Products = lazy(() => import('./IconProducts'));
const PriceBooks = lazy(() => import('./IconPriceBooks'));
const Activities = lazy(() => import('./IconActivities'));
const IconDots = lazy(() => import('./IconDots'));
const IconBell = lazy(() => import('./IconBell'));
const IconMessage = lazy(() => import('./IconMessage'));
const IcontopPlus = lazy(() => import('./IcontopPlus'));
const IcontopUser = lazy(() => import('./IcontopUser'));
const Attachments = lazy(() => import('./IconAttachments'));
const PDF = lazy(() => import('./IconPDF'));
const CSV = lazy(() => import('./IconCSV'));
const OrgList = lazy(() => import('./IconOrgList'));
const Windows = lazy(() => import('./IconWindows'));
const EmailSettings = lazy(() => import('./IconEmailSettings'));
const Imports = lazy(() => import('./IconImports'));
const PersonalInfo = lazy(() => import('./IconPersonalInfo'));
const Users = lazy(() => import('./IconUsers'));
const Permission = lazy(() => import('./IconPermission'));
const WorkFlow = lazy(() => import('./IconWorkFlow'));
const AccountSettings = lazy(() => import('./IconAccountSettings'));
const IconLeftArrow = lazy(() => import('./IconLeftArrow'));
const Profile = lazy(() => import('./IconProfile'));
const CompanyInfo = lazy(() => import('./IconCompanyInfo'));
const ImportExport = lazy(() => import('./IconImportExport'));
const ImportList = lazy(() => import('./IconImportList'));
const Shipping = lazy(() => import('./IconShipping'));
const CRM = lazy(() => import('./IconCRM'));
const Edit = lazy(() => import('./IconEdit'));
const Delete = lazy(() => import('./IconDelete'));
const Filter = lazy(() => import('./IconFilter'));
const FilterList = lazy(() => import('./IconFilterList'));
const AddPlus = lazy(() => import('./IconAddPlus'));
const IconListView = lazy(() => import('./IconListView'));
const IconSplitListView = lazy(() => import('./IconSplitListView'));
const IconGridImport = lazy(() => import('./IconGridImport'));
const AddColumn = lazy(() => import('./IconAddColumn'));
const KanbanView = lazy(() => import('./IconKanbanView'));
const EllipsisH = lazy(() => import('./IconEllipsisH'));
const EllipsisV = lazy(() => import('./IconEllipsisV'));
const TableSort = lazy(() => import('./IconTableSort'));
const Reminder = lazy(() => import('./IconReminder'));
const PopupReminder = lazy(() => import('./IconPopupReminder'));
const Tick = lazy(() => import('./IconTick'));
const ClearFilter = lazy(() => import('./IconClearFilter'));
const Tax = lazy(() => import('./IconTax'));
const Charges = lazy(() => import('./IconCharges'));
const AddPlusTwo = lazy(() => import('./IconAddPlusTwo'));
const Carrier = lazy(() => import('./IconCarrier'));
const Services = lazy(() => import('./IconServices'));
const CarrierAccounts = lazy(() => import('./IconCarrierAccounts'));
const AdditionalServices = lazy(() => import('./IconAdditionalServices'));
const Remove = lazy(() => import('./IconRemove'));
const Task = lazy(() => import('./IconTask'));
const Call = lazy(() => import('./IconCall'));
const Meeting = lazy(() => import('./IconMeeting'));
const Shipments = lazy(() => import('./IconShipments'));
const Addresses = lazy(() => import('./IconAddresses'));
const EmailRemove = lazy(() => import('./IconEmailRemove'));
const EmailRead = lazy(() => import('./IconEmailRead'));
const EmailFailed = lazy(() => import('./IconEmailFailed'));
const EmailQueued = lazy(() => import('./IconEmailQueued'));
const EmailDelivered = lazy(() => import('./IconEmailDelivered'));
const Cross = lazy(() => import('./IconCross'));
const Close2 = lazy(() => import('./IconClose2'));
const CalculateRates = lazy(() => import('./CalculateRatesIcon'));
const IconUpload = lazy(() => import('./IconUpload'));
const IconUploadWhite = lazy(() => import('./IconUploadWhite'));
const IconUploadFiles = lazy(() => import('./IconUploadFiles'));
const IconUploadFolder = lazy(() => import('./IconUploadFolder'));
const Folder = lazy(() => import('./IconFolder'));
const IconPackage = lazy(() => import('./IconPackage'));
const Forecast = lazy(() => import('./IconForecast'));
const AreaChart = lazy(() => import('./IconAreaChart'));
const VChart = lazy(() => import('./IconVChart'));
const HChart = lazy(() => import('./IconHChart'));
const PieChart = lazy(() => import('./IconPieChart'));
const DonutChart = lazy(() => import('./IconDonutChart'));
const Invoices = lazy(() => import('./IconInvoices'));
const IconRightArrow = lazy(() => import('./IconRightArrow'));
const IconSortAsc = lazy(() => import('./IconSortAsc'));
const IconSortDesc = lazy(() => import('./IconSortDesc'));
const ThreeDot = lazy(() => import('./ThreeDot'));
const UpdateIllustration = lazy(() => import('./UpdateIllustration'));
const IconArrowR = lazy(() => import('./IconArrowR'));
const SeperatorIcon = lazy(() => import('./SeperatorIcon'));
const DoubleRightArrow = lazy(() => import('./DoubleRightArrow'));
const IconOthers = lazy(() => import('./IconOthers'));
const IconOffice = lazy(() => import('./IconOffice'));
const IconGmail = lazy(() => import('./IconGmail'));
const ForwardIcon = lazy(() => import('./ForwardIcon'));
const PrintIcon = lazy(() => import('./PrintIcon'));
const MailDeleteIcon = lazy(() => import('./MailDeleteIcon'));
const IconTimeZone = lazy(() => import('./IconTimeZone'));
const InlineCircleIcon = lazy(() => import('./InlineCircleIcon'));
const IconImportant = lazy(() => import('./IconImportant'));
const IconEmailMarkAsRead = lazy(() => import('./IconEmailMarkAsRead'));
const IconEmailArchive = lazy(() => import('./IconEmailArchive'));
const IconEmailTrash = lazy(() => import('./IconEmailTrash'));
const IconEmailMarkAsImportant = lazy(() => import('./IconEmailMarkAsImportant'));
const IconEmailMarkAsUnImportant = lazy(() => import('./IconEmailMarkAsUnImportant'));
const IconEmailAttachment = lazy(() => import('./IconEmailAttachment'));
const IconUnImportant = lazy(() => import('./IconUnImportant'));
const IconEmailMarkAsUnRead = lazy(() => import('./IconEmailMarkAsUnRead'));
const Dashboard = lazy(() => import('./IconDashboard'));
const IconCopy = lazy(() => import('./IconCopy'));
const IconCheckComplete = lazy(() => import('./IconCheckComplete'));
const IconCSVFile = lazy(() => import('./IconCSVFile'));
const IconAdvanceCalculation = lazy(() => import('./IconAdvanceCalculation'));
const IconAdvanceCalculationEdit = lazy(() => import('./IconAdvanceCalculationEdit'));
const IconPlus = lazy(() => import('./IconPlus'));
const LoginIcon = lazy(() => import('./LoginIcon'));
const SignupIcon = lazy(() => import('./SignupIcon'));
const InsertRow = lazy(() => import('./InsertRow'));
const InsertColumn = lazy(() => import('./InsertColumn'));
const FilterOptions = lazy(() => import('./FilterOptions'));
const PreviewLinesIcon = lazy(() => import('./PreviewLinesIcon'));
const IconTags = lazy(() => import('./IconTags'));
const IconLogs = lazy(() => import('./IconLogs'));
const IconAutomation = lazy(() => import('./IconAutomation'));
const IconApi = lazy(() => import('./IconApi'));
const InfoIcon = lazy(() => import('./IconInfo'));
const IconNotes = lazy(() => import('./IconNotes'));
const IconFiles = lazy(() => import('./IconFiles'));
const StepsScreenIcon = lazy(() => import('./StepsScreenIcon'));
const StepsActionIcon = lazy(() => import('./StepsActionIcon'));
const StepsSubflowIcon = lazy(() => import('./StepsSubflowIcon'));
const StepsAssIcon = lazy(() => import('./StepsAssIcon'));
const StepsRecordIcon = lazy(() => import('./StepsRecordIcon'));
const StepsDescIcon = lazy(() => import('./StepsDescIcon'));
const StepsLoopIcon = lazy(() => import('./StepsLoopIcon'));
const StepsStartIcon = lazy(() => import('./StepsStartIcon'));
const StepsRecordAddIcon = lazy(() => import('./StepsRecordAddIcon'));
const StepsRecordEditIcon = lazy(() => import('./StepsRecordEditIcon'));
const StepsRecordDeleteIcon = lazy(() => import('./StepsRecordDeleteIcon'));
const StepsBreakIcon = lazy(() => import('./StepsBreakIcon'));
const IconMinus = lazy(() => import('./IconMinus'));
const ActivityLoader = lazy(() => import('./ActivityLoaderIcon'));
const DomainManagement = lazy(() => import('./DomainManagement'));
const StepsAnimatedFlow = lazy(() => import('./StepsAnimatedFlow'));
const StepsTax = lazy(() => import('./StepsTax'));
const StepsExchangeRate = lazy(() => import('./StepsExchangeRate'));
const StepsStep = lazy(() => import('./StepsStep'));
const StepsSheet = lazy(() => import('./StepsSheet'));
const StepsFile = lazy(() => import('./StepsFile'));
const StepsApi = lazy(() => import('./StepsApi'));
const StepsCalculation = lazy(() => import('./StepsCalculation'));
const StepsAutomation = lazy(() => import('./StepsAutomation'));
const StepsEmail = lazy(() => import('./StepsEmail'));
const StepsTimeDelay = lazy(() => import('./StepsTimeDelay'));
const DotLoader = lazy(() => import('./DotLoader'));
const HTMLLayoutIcon = lazy(() => import('./HTMLLayoutIcon'));
const HTMLBodyIcon = lazy(() => import('./HTMLBodyIcon'));
const DividerIcon = lazy(() => import('./DividerIcon'));
const ButtonIcon = lazy(() => import('./ButtonIcon'));
const HeadingIcon = lazy(() => import('./HeadingIcon'));
const ImageIcon = lazy(() => import('./ImageIcon'));
const GridIcon = lazy(() => import('./GridIcon'));
const TextIcon = lazy(() => import('./TextLabelIcon'));
const MobileIcon = lazy(() => import('./MobileIcon'));
const DesktopIcon = lazy(() => import('./DesktopIcon'));
const AlignmentIcon = lazy(() => import('./AlignmentIcon'));
const CompilerIcon = lazy(() => import('./CompilerIcon'));
const IconMarketPlace = lazy(() => import('./IconMarketPlace'));
const ShareFile = lazy(() => import('./ShareFile'));
const CodeIcon = lazy(() => import('./CodeIcon'));
const PinIcon = lazy(() => import('./pinIcon'));
const ViewMoreIcon = lazy(() => import('./ViewMoreIcon'));
const DummyIcon = lazy(() => import('./DummyIcon'));
const SendEmail = lazy(() => import('./SendEmail'));
const IconFilterClear = lazy(() => import('./IconFilterClear'));
const FormulaIcons = lazy(() => import('./FormulaIcons'));
const StepsRatings = lazy(()=>import('./StepsRatings'));
// const FormulaIcons = lazy(() => import('./FormulaIcons'));
const DownloadIcon=lazy(()=>import('./IconDownload'))
const OpenEmailIcon=lazy(()=>import('./OpenEmailIcon'))
const Icons = {
	'InfoIcon':InfoIcon,
	'DotLoader':DotLoader,
	'ActionMore':ActionMore,
	'Settings' :Settings,
	'Accounts' :Accounts,
	'Reports' :Reports,
	'Lead' :Lead,
	'Contacts' :Contacts,
	'Opportunity' :Opportunity,
	'Cases' :Cases,
	'Campaigns' :Campaings,
	'Products' :Products,
	'Price Books' :PriceBooks,
	'Activities' :Activities,
	'IconDots' :IconDots,
	'IconBell' :IconBell,
	'IconMessage':IconMessage,
	'IcontopPlus' :IcontopPlus,
	'IcontopUser' :IcontopUser,
	'Attachments' :Attachments,
	'PDF' :PDF,
	'CSV' :CSV,
	'OrgList' :OrgList,
	'Windows' :Windows,
	'EmailSettings' :EmailSettings,
	'Imports' :Imports,
	'PersonalInfo' :PersonalInfo,
	'Dashboard' :Dashboard,
	'Users' :Users,
	'Permission' :Permission,
	'WorkFlow' :WorkFlow,
	'AccountSettings' :AccountSettings ,
	'IconLeftArrow' :IconLeftArrow,
	'Profile' :Profile,
	'CompanyInfo' :CompanyInfo,
	'ImportExport' :ImportExport,
	'ImportList' :ImportList,
	'SHIPPING' :Shipping,
	'CRM' :CRM,
	'Edit' :Edit,
    'Delete' :Delete ,
	'Filter' :Filter,
	'FilterList' :FilterList,
	'AddPlus' :AddPlus,
	'IconGridImport' :IconGridImport,
	'IconListView' :IconListView,
	'AddColumn' :AddColumn,
	'KanbanView' :KanbanView,
	'EllipsisH' :EllipsisH,
	'EllipsisV' :EllipsisV,
	'TableSort' :TableSort,
	'Reminder' :Reminder,
	'PopupReminder' :PopupReminder,
	'Tick' :Tick,
	'ClearFilter' :ClearFilter,
	'Tax' :Tax,
	'Charges' :Charges,
	'AddPlusTwo' :AddPlusTwo,
	'Carrier' :Carrier,
	'Services' :Services,
	'Carrier Accounts' :CarrierAccounts,
	'Additional Services' :AdditionalServices,
	'Remove' :Remove,
	'Task' :Task,
	'Call' :Call,
	'Meeting' :Meeting,
	'Shipments' :Shipments,
	'Addresses' :Addresses,
	'EmailRemove' :EmailRemove,
	'EmailRead' :EmailRead,
	'EmailFailed' :EmailFailed,
	'EmailQueued' :EmailQueued,
	'EmailDelivered' :EmailDelivered,
	'Cross' :Cross,
	'CalculateRates' :CalculateRates,
	'UploadIcon' :IconUpload,
	'UploadIconWhite' :IconUploadWhite,
	'UploadIconFiles' :IconUploadFiles,
	'UploadIconFolder' :IconUploadFolder,
	'Folder' :Folder,
	'Package':IconPackage,
	'Forecast':Forecast,
	'AreaChart':AreaChart,
	'VChart':VChart,
	'HChart':HChart,
	'PieChart':PieChart,
	'DonutChart':DonutChart,
	'Invoices' :Invoices,
	'IconRightArrow' :IconRightArrow,'SortAsc' :IconSortAsc,
	'SortDesc' :IconSortDesc,
	'ThreeDot' :ThreeDot,
	'UpdateIllustration' :UpdateIllustration,
	'IconSplitListView':IconSplitListView,
	'Close2':Close2,
	'IconArrowR':IconArrowR,
	'SeperatorIcon':SeperatorIcon,
	'DoubleRightArrow':DoubleRightArrow,
	'IconOthers':IconOthers,
	'IconOffice':IconOffice,
	'IconGmail':IconGmail,
	'ForwardIcon':ForwardIcon,
	'PrintIcon':PrintIcon,
	'MailDeleteIcon':MailDeleteIcon,
	'IconTimeZone' :IconTimeZone,
	'InlineCircleIcon' :InlineCircleIcon,
	'Important' :IconImportant,
	'UnImportant' :IconUnImportant,
	'EmailMarkAsRead' :IconEmailMarkAsRead,
	'EmailMarkAsUnRead' :IconEmailMarkAsUnRead,
	'EmailArchive' :IconEmailArchive,
	'EmailTrash' :IconEmailTrash,
	'EmailMarkAsImportant' :IconEmailMarkAsImportant,
	'EmailMarkAsUnImportant' :IconEmailMarkAsUnImportant,
	'EmailAttachment' :IconEmailAttachment,
	'Copy' :IconCopy,
	'CheckComplete' :IconCheckComplete,
	'CSVFile' :IconCSVFile,
	'AdvanceCalculation' :IconAdvanceCalculation,
	'AdvanceCalculationEdit' :IconAdvanceCalculationEdit,
	'IconPlus' :IconPlus,
	'LoginIcon' :LoginIcon,
	'SignupIcon' :SignupIcon,
	'InsertRow' :InsertRow,
	'InsertColumn' :InsertColumn,
	'FilterOptions' :FilterOptions,
	'PreviewLinesIcon' :PreviewLinesIcon,
	'IconTags' :IconTags,
	'IconLogs' :IconLogs,
	'IconAutomation' :IconAutomation,
 	'IconApi' :IconApi,
	'IconNotes' :IconNotes,
	'IconFiles' :IconFiles,
	'StepsSubflow' :StepsSubflowIcon,
	'StepsAction' :StepsActionIcon,
	'StepsAss' :StepsAssIcon,
	'StepsDesc' :StepsDescIcon,
	'StepsLoop' :StepsLoopIcon,
	'StepsScreen' :StepsScreenIcon,
	'StepsStart':StepsStartIcon,
	'StepsRecord':StepsRecordIcon,
	'StepsRecordAdd':StepsRecordAddIcon,
	'StepsAnimatedFlow':StepsAnimatedFlow,
	'StepsRecordEdit':StepsRecordEditIcon,
	'StepsRecordDelete':StepsRecordDeleteIcon,
	'StepsBreak':StepsBreakIcon,
	'StepsRating':StepsRatings,
	'DomainManagement':DomainManagement,
	'EMPTY':<></>,
	'IconMinus':IconMinus,
	'ActivityLoader':ActivityLoader,
	'StepsTax':StepsTax,
	'StepsExchangeRate':StepsExchangeRate,
	'StepsStep':StepsStep,
	'StepsSheet':StepsSheet,
	'StepsFile':StepsFile,
	'StepsApi':StepsApi,
	'StepsCalculation':StepsCalculation,
	'StepsAutomation':StepsAutomation,
	'StepsEmail':StepsEmail,
	'StepsTimeDelay':StepsTimeDelay,
	'HTMLLayout':HTMLLayoutIcon,
	'HTMLBody':HTMLBodyIcon,
	'DividerIcon':DividerIcon,
	'ButtonIcon':ButtonIcon,
	'HeadingIcon':HeadingIcon,
	'ImageIcon':ImageIcon,
	'GridIcon':GridIcon,
	'TextIcon':TextIcon,
	'DesktopIcon':DesktopIcon,
	'MobileIcon':MobileIcon,
	'Alignment':AlignmentIcon,
	'compiler':CompilerIcon,
	"StepsCode":CompilerIcon,
	'MarketPlaceIcon' :IconMarketPlace,
	"CodeIcon":CodeIcon,
	'ShareFile':ShareFile,
	"StepsFtp":ShareFile,
	"PinIcon":PinIcon,
	"Dummy":DummyIcon,
	"ViewMore":ViewMoreIcon,
	"SendEmail":SendEmail,
	"IconFilterClear":IconFilterClear,
	"FormulaIcons":FormulaIcons,
	"RatingsAssignment":RatingsAssignmentIcon,
	"RatingsDecision":RatingsDecisionIcon,
	"RatingsLoop":RatingsLoopIcon,
	"RatingsBreak":RatingsBreakIcon,
	"RatingsThread":RatingsThreadIcon,
	"DownloadIcon":DownloadIcon,
	"OpenEmailIcon":OpenEmailIcon
}

export default Icons